export default "__VITE_ASSET__DdtfkfHw__"